module.exports = __webpack_public_path__ + "static/media/img1.cc5c0704.svg";